import { type FC } from "react";
import { Tag, Text } from "../../primitives";
import type { WipAnalysisPeriodSelectorItem } from "./wipAnalysisPeriodSelection";
import { formatWipPeriodDateLabel, formatWipPeriodTypeLabel } from "./wipPeriod";

const SCHEDULE_OF_RECORD_TAG_TEST_ID = "wip-analysis-schedule-of-record-tag";

type WipAnalysisPeriodSelectorLabelProps = {
	item: WipAnalysisPeriodSelectorItem;
};

export const WipAnalysisPeriodSelectorLabel: FC<WipAnalysisPeriodSelectorLabelProps> = ({
	item,
}) => (
	<>
		<div className="flex flex-wrap items-center gap-1.5">
			<Text type="body-strong">{formatWipPeriodDateLabel(item.statementDate)}</Text>
			{item.isScheduleOfRecord && (
				<Tag color="blue" testId={SCHEDULE_OF_RECORD_TAG_TEST_ID}>
					Schedule of record
				</Tag>
			)}
		</div>
		<Text type="caption" color="tertiary">
			{formatWipPeriodTypeLabel(item.periodType, item.preparationMethod)}
		</Text>
	</>
);
